export function agentStateForLog(agent: connect.Agent) {
    const contactsSummary = agent.getContacts().map((c) => ({
        id: c.getContactId(),
        type: c.getType(),
        state: c.getState()?.type,
    }));
    const { state, timeStamp, type } = agent.getAvailabilityState();
    return {
        agentNextState: agent.getNextState()?.name || null,
        agentAvailabilityState: state,
        // AgentStateType (routable / not_routable / offline / error / system) — lets us tell a system
        // "error" block (e.g. MissedCallAgent) apart from an agent-selected aux like lunch/meeting.
        agentStateType: type,
        agentAvailabilityStateUpdatedAt: timeStamp.toISOString(),
        contactsCount: contactsSummary.length,
        contactsSummary,
    };
}
